// src/components/VideoBackground.jsx
import React, { useRef, useEffect } from 'react';
import ShapeTwo from './shape-two';

const VideoBackground = ({ videoSrc, children, playbackRate = 1 }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = playbackRate;
    }
  }, [playbackRate]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
      <video
        ref={videoRef}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          minWidth: '100%',
          minHeight: '100%',
          width: 'auto',
          height: 'auto',
          transform: 'translate(-50%, -50%)',
          zIndex: -1,
          objectFit: 'cover',
          opacity: '1'
        }}
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={videoSrc} type="video/mp4" />
        Tu navegador no soporta el tag de video.
      </video>
      <div style={{ position: 'relative', zIndex: 1 }}>
        {children}
        <ShapeTwo />
      </div>
    </div>
  );
};

export default VideoBackground;